/** Custom dashboards that load their own data — do not also run useDashboard warehouse fetches. */
export const CUSTOM_DASHBOARD_KEYS = {
    account_overview: true,
    company_overview: true,
    crm_administration: true,
    executive: true,
    my_performance: true,
    overview: true,
    team: true,
    finance_overview: true,
};

export function isCustomDashboardKey(key) {
    return Boolean(key && CUSTOM_DASHBOARD_KEYS[key]);
}

export function dashboardNeedsWarehouseFetch(config, key) {
    if (isCustomDashboardKey(key)) return false;
    const widgets = config?.widgets || [];
    return widgets.some((w) => typeof w === 'string');
}
